import { Injectable, signal, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AppStateService implements OnDestroy {
  isEmbed = signal(false);
  learningMode = signal(false);
  endpoint = signal('');
  editMode = signal(false);
  isLargeScreen = signal<boolean>(window.innerWidth > 768);

  screenSize = signal('');

  private resizeListener: () => void;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    // Initial screen size detection
    this.detectScreenSize();
    
    // Set up resize listener
    this.resizeListener = () => this.detectScreenSize();
    window.addEventListener('resize', this.resizeListener);

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        // console.log('val', val);
        this.isEmbed.set(this.checkEmbedRoute(val.url));
        this.setEndpoint(val.url);
      }
    });
    window.addEventListener('resize', () => {
      const isLarge = window.innerWidth > 768;
      this.isLargeScreen.set(isLarge);
    });
  }

  ngOnDestroy() {
    // Clean up the resize listener when the service is destroyed
    window.removeEventListener('resize', this.resizeListener);
  }

  setEndpoint(fullPath: string) {
    if (fullPath.includes('learning')) {
      this.endpoint.set('learning');
      this.learningMode.set(true);
    }
    else if (fullPath.includes('binders/edit') || fullPath.includes('embed/edit')) {
      this.endpoint.set('binder');
    }

    else if (fullPath.includes('ops/assemblies')) {
      this.endpoint.set('assembly');
    }
    else {
      this.endpoint.set('');
    }
  }

  checkEmbedRoute(fullPath: string) {
    return fullPath.startsWith('/embed');
  }

  get isBinderEditor() {
    return this.endpoint().includes('binders/edit');
  }

  get isAssemblyEditor() {
    return this.endpoint().includes('ops/assemblies');
  }

  detectScreenSize() {
    const screenWidth = window.innerWidth;
    if(screenWidth < 768) {
      this.screenSize.set('mobile');
    }
    else if(screenWidth < 1024) {
      this.screenSize.set('tablet');
    }
    else {
      this.screenSize.set('desktop');
    }
  }

  setLearningMode(mode: boolean) {
    this.learningMode.set(mode);
  }

  setEditMode(mode: boolean) {
    this.editMode.set(mode);
  }

}
